<template>
  <div class="main_box">
    <h2 class="hidden-md-and-up">充值中心</h2>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <span style="color: #eb0800">请选择充值次数</span>
          <span>（多充多优惠！）</span>
        </div>
        <div class="form_bar_btn"></div>
      </div>
      <el-row>
        <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
          <div
            class="buy_form_plan"
            v-for="(item, index) in products"
            :key="item.ID"
          >
            <div
              :class="[
                selectProductIndex === index
                  ? 'buy_option_active'
                  : 'buy_option'
              ]"
              @click="selectActive(index)"
              @mouseover="optionMouseover(index)"
              @mouseout="optionMouseout(index)"
            >
              <div class="buy_option_main">
                <div class="buy_option_main_title">
                  {{ item.ProjectName }}
                </div>
              </div>
              <div class="buy_option_divider">
                <div
                  :class="[
                    selectProductIndex === index
                      ? 'buy_option_divider_triangle__down_active'
                      : 'buy_option_divider_triangle__down',
                    hoveIndex === index
                      ? 'buy_option_divider_triangle__down_active'
                      : 'buy_option_divider_triangle__down'
                  ]"
                ></div>
                <div
                  :class="[
                    selectProductIndex === index
                      ? 'buy_option_divider_triangle__up_active'
                      : 'buy_option_divider_triangle__up',
                    hoveIndex === index
                      ? 'buy_option_divider_triangle__up_active'
                      : 'buy_option_divider_triangle__up'
                  ]"
                ></div>
              </div>
              <div class="buy_option_quantity">
                <el-input-number
                  v-model="item.Quantity"
                  :step="1"
                  step-strictly
                  size="mini"
                  width="110"
                  :disabled="selectProductIndex !== index"
                ></el-input-number>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="buy_digital">
            您需支付：
            <span class="buy_digital_num">
              {{ TotalAmount }}
            </span>
            <span class="buy_digital_unit">元</span>
          </div>
          <div class="buy_operate">
            <el-button class="buy_operate_btn" @click="alipay()"
              >立即支付</el-button
            >
          </div>
          <div class="buy_tip">
            <span>目前仅支持</span>
            <i class="iconfont icon-zhifubao"></i>
            <span>支付宝支付</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import alipayApi from '../../../api/alipay'
export default {
  data () {
    return {
      products: [],
      selectProductIndex: 0,
      TotalAmount: 0.00,
      hoveIndex: -1
    }
  },
  methods: {
    initializeMoney: function () {
      const _this = this
      _this.openLoading()
      _this.$api.moneyUsering.initializeMoney().then(data => {
        _this.getProductList()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getProductList: function () {
      const _this = this
      _this.openLoading()
      _this.$api.moneyUsering.getProductList().then(data => {
        _this.products = data
        _this.products.forEach(function (item, index) {
          item.Quantity = 1
        })
        this.selectActive(0)
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    selectActive: function (index) {
      this.selectProductIndex = index
      this.TotalAmount = this.products[index].Money * this.products[index].Quantity
    },
    optionMouseover: function (index) {
      this.hoveIndex = index
    },
    optionMouseout: function (index) {
      if (this.hoveIndex !== this.selectProductIndex) {
        this.hoveIndex = -1
      }
    },
    alipay: function () {
      const _this = this
      // _this.openLoading()
      alipayApi.getAlipayFormHtml(
        {
          MoneyProductId: _this.products[_this.selectProductIndex].ID,
          ProductNum: _this.products[_this.selectProductIndex].Quantity,
          Price: _this.TotalAmount
        }
      ).then(data => {
        const div = document.createElement('div')
        div.id = 'alipayBox'
        div.innerHTML = data
        document.body.appendChild(div)
        // document.querySelector('body').innerHTML = data // 查找到当前页面的body，将后台返回的form替换掉他的内容
        document.forms[0].submit()
        div.remove()
        // _this.openLoading().close()
      }).catch(err => {
        // _this.openLoading().close()
        return err
      })
    }
  },
  created () {
    this.initializeMoney()
  }
}
</script>
<style lang="less">
.el-input-number--mini {
  width: 110px;
}
</style>
